import { Component } from '@angular/core';

@Component({
    selector: 'app-confidentialite',
    templateUrl: './confidentialite.component.html',
    styleUrl: './confidentialite.component.css'
})
export class ConfidentialiteComponent {

}
